import { Route } from "react-router-dom";
import { SimpleErrorBoundary } from "~/components";
import { lazyNamedPage } from "~/utils/routing/lazyPage";
import {
  AddPropertyPageLoader,
  AddPropertyPageAction,
} from "./AddPropertyPage/loaders";
import {
  PropertyDetailsPageLoader,
  PropertyDetailsPageAction,
} from "./PropertyDetailsPage/loaders";
import {
  PropertyTablePageLoader,
  propertyTableShouldRevalidate,
} from "./PropertyTablePage/loaders";

const PropertyTablePage = lazyNamedPage("PropertyTablePage", () =>
  import(
    /* webpackChunkName: "property" */
    "./PropertyTablePage/PropertyTablePage"
  ),
);
const AddPropertyPage = lazyNamedPage("AddPropertyPage", () =>
  import(
    /* webpackChunkName: "property" */
    "./AddPropertyPage/AddPropertyPage"
  ),
);
const PropertyDetailsPage = lazyNamedPage("PropertyDetailsPage", () =>
  import(
    /* webpackChunkName: "property" */
    "./PropertyDetailsPage/PropertyDetailsPage"
  ),
);

/**
 * Public routes for Property pages (accessible to unauthenticated users)
 * Returns only the table/list page route
 */
export const PropertyPagesPublicRoutes = () => {
  return (
    <Route
      path="/property"
      loader={PropertyTablePageLoader}
      shouldRevalidate={propertyTableShouldRevalidate}
      ErrorBoundary={() => SimpleErrorBoundary()}
      element={<PropertyTablePage />}
    />
  );
};

/**
 * Protected routes for Property pages (require authentication)
 * Returns detail and add page routes
 */
export const PropertyPagesProtectedRoutes = () => {
  return (
    <>
      <Route
        path="/add-property"
        loader={AddPropertyPageLoader}
        action={AddPropertyPageAction}
        ErrorBoundary={() => SimpleErrorBoundary()}
        element={<AddPropertyPage />}
      />
      <Route
        path="/property/:propertyID"
        loader={PropertyDetailsPageLoader}
        action={PropertyDetailsPageAction}
        ErrorBoundary={() => SimpleErrorBoundary()}
        element={<PropertyDetailsPage />}
      />
    </>
  );
};

/**
 * Legacy export - returns all routes (for backwards compatibility if needed)
 * @deprecated Use PropertyPagesPublicRoutes() and PropertyPagesProtectedRoutes() instead
 */
export const PropertyPagesRoutes = () => {
  return (
    <>
      {PropertyPagesPublicRoutes()}
      {PropertyPagesProtectedRoutes()}
    </>
  );
};
